<template>
    <div :class="classes" style="display:none"></div>
</template>

<script>
import $ from 'jquery';
import Mark from 'mark.js';

export default {
  name: 'TextHighlighter',
  props: {
    type        : '',
    element     : null,
    definition  : {},
    classes     : '',
    selected    : false,
    active      : false,
    disabled    : false
  },

  data() {
    return {
      identifier    : 'jbo-element-' + this._uid,
      marker        : null,
      marks         : null
    }
  },

  mounted() {
    this.mark()
  },
  updated() {
    this.mark()
    this.marks.attr('class', this.identifier + ' ' + this.classes)
  },
  beforeDestroy() {
    $(this.element).off('click mouseup keyup', this.click)
    this.unmark()
  },

  methods: {
    click(ev) {
      if (!this.disabled) {
        ev && (ev.stopImmediatePropagation(), ev.preventDefault())
        this.$parent.$emit('click', this.$parent, this.marks)
      }
    },
    
    mark() {
      this.marker = this.marker || new Mark(this.element)
      this.marker.markRegExp(new RegExp(this.definition.c, 'gim'), {
        separateWordSearch    : false,
        acrossElements        : false,
        diacritics            : false,
        className             : this.identifier + ' ' + this.classes,
        exclude               : ['mark.jbo-overlay'],
        done                  : () => {
          this.marks = $('.' + this.identifier, this.element)
          $('.' + this.identifier, this.element).on('click mouseup keyup', this.click)
          
          // If this is a new user selection, trigger a fake click to start the tagging process
          if (this.active && !this.definition.hasOwnProperty('i')) {
            this.definition.i = null
            this.click()
          }
        }
      })
    },
    
    unmark() {
      if (this.marker)
        this.marker.unmark({
          className: this.identifier
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// TextHighlighter.vue?1a7a66d4